import React from 'react';
export function HookSection() {
  return <section className="w-full bg-cream-dark py-16 md:py-24 px-4" data-id="element-56">
      <div className="max-w-3xl mx-auto text-center" data-id="element-57">
        <h2 className="text-3xl md:text-4xl font-bold text-brown-primary mb-8 font-serif italic" data-id="element-58">
          ¿Te suena familiar?
        </h2>

        <div className="space-y-6 text-lg md:text-xl text-brown-secondary leading-relaxed" data-id="element-59">
          <p data-id="element-60">
            Te entiendo perfectamente. Te ves al espejo y ahí están: los poros
            abiertos, esa textura irregular que el maquillaje no logra tapar y
            esa{' '}
            <span className="font-semibold text-brown-primary" data-id="element-61">
              "piel opaca"
            </span>{' '}
            que te hace ver cansada (aunque hayas dormido bien).
          </p>

          <p data-id="element-62">
            Ves a las influencers con su piel radiante y piensas:{' '}
            <span className="italic text-brown-primary" data-id="element-63">
              "Claro, con rutinas de 5 mil pesos cualquiera"
            </span>
            .
          </p>
        </div>

        <div className="mt-12 w-16 h-1 bg-rose-gold/30 mx-auto rounded-full" data-id="element-64"></div>
      </div>
    </section>;
}